import { userQueryKeys } from '../queries/userQueryKeys.js';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useWoody } from '../../woody/woody.js';
import { toast } from '../../store/alerts.js';
import { useOptimisticallyUpdateQueryDetailData } from '@fabric-app/queries/utilities';

const mergePreferences = (currentData, data) => {
  return {
    ...currentData,
    ...data,
    ai: {
      ...currentData?.ai,
      ...data.ai
    },
    frontend: {
      ...currentData?.frontend,
      ...data.frontend,
      labs: {
        ...currentData?.frontend?.labs,
        ...data.frontend?.labs
      }
    }
  };
};
const useMutationUserPreferencesUpdate = () => {
  const queryClient = useQueryClient();
  const optimisticallyUpdateQueryDetailData = useOptimisticallyUpdateQueryDetailData();
  const { client } = useWoody();
  return useMutation({
    mutationFn: async ({ data }) => {
      const currentData = queryClient.getQueryData(userQueryKeys.userPreferences());
      return await client.v2("/v2/user/preferences", {
        method: "put",
        /**
        * merge first level data
        */
        body: mergePreferences(currentData, data)
      });
    },
    onMutate: ({ data }) => {
      queryClient.cancelQueries({
        queryKey: userQueryKeys.userPreferences()
      });
      const currentData = queryClient.getQueryData(userQueryKeys.userPreferences());
      return optimisticallyUpdateQueryDetailData(userQueryKeys.userPreferences(), mergePreferences(currentData, data));
    },
    onSuccess: (_, { showToast = true }) => {
      if (!showToast) return;
      toast({
        content: "Preferences have been updated"
      });
    },
    onError: (_error, { showToast = true }, context) => {
      context?.resetDetailData();
      context?.invalidateQueries();
      if (!showToast) return;
      toast({
        content: "Failed to update user preferences"
      });
    }
  });
};

export { useMutationUserPreferencesUpdate };
//# sourceMappingURL=useMutationUserPreferencesUpdate.js.map
